import { Button, Descriptions, Popconfirm, Space } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useNavigate, useParams, useRouteLoaderData } from "react-router";
import BackTitle from "../common/BackTitle";
import { api } from "../common/api";

export default function Tag() {
  const data = useRouteLoaderData("tag");
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <div>
      <BackTitle
        backEnabled={false}
        title={data.name}
        secondary={`ID: ${id}`}
        extra={
          <Space>
            <Button icon={<EditOutlined />} onClick={() => navigate("edit")}>
              Modifica
            </Button>
            <Popconfirm
              title="Eliminare questo tag?"
              okText="Elimina"
              cancelText="Annulla"
              onConfirm={() => api.tag.delete(id).then(() => navigate("/tags"))}
            >
              <Button danger icon={<DeleteOutlined />}>
                Elimina
              </Button>
            </Popconfirm>
          </Space>
        }
      />
      <Descriptions
        layout="vertical"
        items={[
          { key: "name", label: "Nome", children: data.name },
          {
            key: "includeInHseDocuments",
            label: "Includi nei documenti HSE",
            children: data.includeInHseDocuments ? "Sì" : "No",
          },
          {
            key: "requiresDueDate",
            label: "Richiede scadenza",
            children: data.requiresDueDate ? "Sì" : "No",
          },
        ]}
      />
    </div>
  );
}
